/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_A5Inputs */

const en_directory_home_faq_a5 = /** @type {(inputs: Directory_Home_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Paid plans buy faster review and better placement, but every product passes the same editorial check.`)
};

const zh_directory_home_faq_a5 = /** @type {(inputs: Directory_Home_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不能。付费方案带来更快的审核和更好的展示位，但每个产品都要通过同样的编辑审核。`)
};

/**
* | output |
* | --- |
* | "No. Paid plans buy faster review and better placement, but every product passes the same editorial check." |
*
* @param {Directory_Home_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_a5 = /** @type {((inputs?: Directory_Home_Faq_A5Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_A5Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_a5(inputs)
	return zh_directory_home_faq_a5(inputs)
});
export { directory_home_faq_a5 as "directory.home.faq.a5" }